import { render, staticRenderFns } from "./BookingItem.vue?vue&type=template&id=558762f4&scoped=true"
import script from "./BookingItem.vue?vue&type=script&lang=js"
export * from "./BookingItem.vue?vue&type=script&lang=js"
import style0 from "./BookingItem.vue?vue&type=style&index=0&id=558762f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558762f4",
  null
  
)

export default component.exports